import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { comparerByAlphabet } from '@app/comparers';

import {
  HangerActionsUnion,
  HangerActionTypes
} from '@core/actions/hanger.actions';

import { Hanger } from '@app/models';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface State extends EntityState<Hanger> {
  loading: boolean;
  loaded: boolean;
}

export const adapter: EntityAdapter<Hanger> = createEntityAdapter<Hanger>({
  selectId: (hanger: Hanger) => hanger.id,
  sortComparer: comparerByAlphabet('ASC', 'model')
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false
});

export function reducer(
  state: State = INITIAL_STATE,
  action: HangerActionsUnion
) {
  switch (action.type) {
    case HangerActionTypes.Load:
      return { ...state, loading: true };

    case HangerActionTypes.DeleteHangerFail:
    case HangerActionTypes.LoadFail:
      return { ...state, loading: false };

    case HangerActionTypes.DeleteHangerSuccess:
    case HangerActionTypes.LoadSuccess:
      return { ...state, loading: false, loaded: true };

    case HangerActionTypes.AddAll:
      return adapter.addAll(action.hangers, state);

    case HangerActionTypes.AddOne:
      return adapter.addOne(action.hanger, state)

    case HangerActionTypes.UpdateHanger:
      return adapter.updateOne({ id: action.id, changes: action.hanger }, state);

    case HangerActionTypes.DeleteHanger:
      return adapter.removeOne(action.hangerId, state);

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

const selectLoaded = (state: State) => state.loaded;
const selectLoading = (state: State) => state.loading;

const getState = createFeatureSelector<State>('hangers');

export const getAll = createSelector(getState, selectAll);
